import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function UpdateGrid() {
  const featuredComic = comics[0];
  const restComics = comics.slice(1, 7);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100">每日更新</h2>
            <p className="text-foreground-500 text-sm mt-2">精选优质漫画，每日稳定更新，让你追漫不停歇</p>
          </div>
          <a href="/category" className="text-primary-500 hover:text-primary-400 text-sm flex items-center gap-1 transition-colors whitespace-nowrap">
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          <div className="lg:col-span-2 lg:row-span-2">
            <ComicCard
              id={featuredComic.id}
              title={featuredComic.title}
              cover={featuredComic.cover}
              author={featuredComic.author}
              status={featuredComic.status}
              category={featuredComic.category}
              rating={featuredComic.rating}
              views={featuredComic.views}
              tags={featuredComic.tags}
              isHot={featuredComic.isHot}
              isNew={featuredComic.isNew}
              variant="featured"
            />
          </div>
          {restComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              cover={comic.cover}
              author={comic.author}
              status={comic.status}
              category={comic.category}
              rating={comic.rating}
              views={comic.views}
              tags={comic.tags}
              isHot={comic.isHot}
              isNew={comic.isNew}
            />
          ))}
        </div>
      </div>
    </section>
  );
}